var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 7.5C20.6138 7.5 21.1653 7.87343 21.3931 8.44291L29.3931 28.4429C29.7008 29.2121 29.3267 30.085 28.5575 30.3927C27.7883 30.7004 26.9154 30.3263 26.6077 29.5571L20.0004 13.0389L13.3931 29.5571C13.0854 30.3263 12.2125 30.7004 11.4433 30.3927C10.6741 30.085 10.3 29.2121 10.6077 28.4429L18.6077 8.44291C18.8355 7.87343 19.387 7.5 20.0004 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0004 22.5C14.0004 21.6716 14.672 21 15.5004 21H24.5004C25.3288 21 26.0004 21.6716 26.0004 22.5C26.0004 23.3284 25.3288 24 24.5004 24H15.5004C14.672 24 14.0004 23.3284 14.0004 22.5Z",
    fill: "white"
  })));
}

export default SvgTextGlyph;